import { graphql } from 'gql/generated'

export const GET_ROUTING_LAYERS = graphql(`
  query GetRoutingLayers($input: RoutingLayersInput, $pagination: PaginationV2) {
    routingLayers(input: $input, pagination: $pagination) {
      total
      items {
        id
        name
        type
        isActive
        createdAt
      }
    }
  }
`)

export const GET_ALL_ACTIVE_ROUTING_LAYERS = graphql(`
  query GetAllActiveRoutingLayers {
    routingLayers(input: { isActive: true }, pagination: { page: 1, size: 1000 }) {
      total
      items {
        id
        name
        type
        locationsGroup {
          id
          color
          icon
          locations {
            id
            label
            coordinates {
              latitude
              longitude
            }
          }
        }
        polygons {
          id
          color
          lineWidth
          transparency
          label
          coordinates {
            latitude
            longitude
          }
        }
      }
    }
  }
`)
